const isScreen =
  (breakpoints) =>
  (...sizes) =>
    sizes.some((size) => breakpoints[size]);

export default isScreen;
